import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import MediaCardFull from '../mediaCard/MediaCardFull'
import './MediaList.css'

/**
 * Component for displaying multiple `MediaCard`s in a grid.
 *
 * @param {object} props - component props
 * @returns {function} Component
 */
function MediaList(props) {
  const { className, media, mediaType, isSearch, updateMedia, ...rest } = props

  const mediaList = classNames('MediaList', className)
  const mediaListItem = classNames('MediaListItem', className)

  /** TODO render an empty state. */
  if (!media.length) {
    return false
  }

  return (
    <div className={mediaList}>
      {media.map((mediaItem, i) => {
        const accessor = mediaItem && mediaItem.audiobook ? 'audiobook' : 'ebook'
        const sku = mediaItem[accessor] && mediaItem[accessor].sku

        return (
          <div className={mediaListItem} key={`${mediaItem.mediaId}-${sku}-${i}`} {...rest}>
            <MediaCardFull media={mediaItem} updateMedia={updateMedia} mediaType={accessor} />
          </div>
        )
      })}
    </div>
  )
}

MediaList.defaultProps = {
  className: '',
  media: [],
  isSearch: false,
  mediaType: 'ebook',
  updateMedia: () => {},
}

MediaList.propTypes = {
  /** Additional classes */
  className: PropTypes.string,
  /** Media objects to display as `MediaCard`s */
  media: PropTypes.arrayOf(PropTypes.shape({})),
  /** Whether the Media objects are search results */
  isSearch: PropTypes.bool,
  /** Type of media to display, ebook or audiobook */
  mediaType: PropTypes.string,
  updateMedia: PropTypes.func,
}

export default MediaList
